package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier

@Composable
fun Divider(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .styleModifier {
                property("height", "0.5px")
                property("background", "linear-gradient(90deg, transparent, rgba(148,149,152,0.35) 50%, transparent)")
                property("flex-shrink", "0")
            }
    )
}
